import * as yup from 'yup';

import { REGEXP } from 'constants/commonConstants';

export const projectCopySchema = yup.object().shape({
  copyProjectName: yup
    .string()
    .required('프로젝트 명을 입력해주세요.')
    .matches(REGEXP.PROJECT_NAME, '2-50자의 영문, 숫자, -, _의 조합으로 이루어져야합니다.'),
});
